import { AccountOrganization } from '@/types/account-organization.model'
import { AccountOrganizationRole } from '@/types/account-organization-role.model'

export class AccountInfo {
  constructor(init: Partial<AccountInfo> = {}) {
    this.accountId = init.accountId || ''
    this.organizationAccountId = init.organizationAccountId || ''
    this.organization = init.organization || new AccountOrganization()
    this.organizationRole = init.organizationRole || new AccountOrganizationRole()
    this.isInactive = init.isInactive || false
    this.permissions = init.permissions || []
  }

  accountId: string
  organizationAccountId: string
  organization: AccountOrganization
  organizationRole: AccountOrganizationRole
  isInactive: boolean
  permissions: string[]
}
